module.exports = __webpack_public_path__ + "img/img2.ec4d3f77.jpg";